import React from 'react'
import { formatDate } from '../../../../utils/format'

const Note = ({ author, note, onDelete }) => (
  <div className="note">
    <p className='noteUsername'>{(author && author.name) || 'User' } left a note on {formatDate(note.created_at)}</p>
    <p className='noteMessage'>{note.message}</p>

    <a href="#" className='button small danger no-shadow' onClick={(e) => onDelete(e, note.id)}>Delete Note</a>
  </div>
)

export default Note



// WEBPACK FOOTER //
// client/components/sections/website/Leads/Note.js